// ./component/App/App.js
import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import {
  Switch,
  Route,
} from "react-router-dom";
import HomePage from "../../Pages/HomePage";
import LoginPage from "../../Pages/LoginPage"; 
import BlogPost from "../../Pages/BlogPost"; 
import CreatePage from "../../Pages/CreatePage";
import Header from "../Header";
import { getMe } from "../../WebApi";
import { AuthContext } from "../../contexts";
import { getAuthToken } from "../../utils";

const Root =  styled.div`
  padding-top: 64px;
`;

export default function App() {
  const [user, setUser] = useState();
  const [isDone, setIsDone] = useState(false);
  // const isDone = useRef(false);
  
  useEffect(() =>{
    const token = getAuthToken();
    if (token) {
      getMe().then(resp =>{
        if (resp.ok === 1) {
          setUser(resp.data);
        }
      });
    }
    setIsDone(true);
  }, []);

  return (
    <AuthContext.Provider value={{user, setUser}}>
      <Root>
        <Header done={isDone} />
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="/posts/:slug">
            <BlogPost />
          </Route>
          <Route path="/new-post">
            <CreatePage />
          </Route>
          <Route path="/login">
            <LoginPage />
          </Route>
        </Switch>
      </Root>
    </AuthContext.Provider>
  );
}
